import { create } from 'zustand';

/**
 * Ephemeral interface state.
 *
 * Nothing here is server state and nothing here is persisted - it is what the
 * interface is *doing right now*. Server data lives in TanStack Query and is
 * never copied into a store, because two caches of the same fact eventually
 * disagree and the bug surfaces as a stale price.
 */

interface UiState {
  cartOpen: boolean;
  searchOpen: boolean;
  mobileNavOpen: boolean;
  /** Announced to screen readers via a live region. */
  announcement: string | null;

  openCart: () => void;
  closeCart: () => void;
  toggleSearch: (open?: boolean) => void;
  toggleMobileNav: (open?: boolean) => void;
  announce: (message: string) => void;
  closeAll: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  cartOpen: false,
  searchOpen: false,
  mobileNavOpen: false,
  announcement: null,

  // Opening one overlay closes the others: two stacked drawers would trap
  // focus in whichever mounted last.
  openCart: () => set({ cartOpen: true, searchOpen: false, mobileNavOpen: false }),
  closeCart: () => set({ cartOpen: false }),
  toggleSearch: (open) =>
    set((state) => ({ searchOpen: open ?? !state.searchOpen, cartOpen: false, mobileNavOpen: false })),
  toggleMobileNav: (open) =>
    set((state) => ({ mobileNavOpen: open ?? !state.mobileNavOpen, cartOpen: false, searchOpen: false })),
  announce: (message) => set({ announcement: message }),
  closeAll: () => set({ cartOpen: false, searchOpen: false, mobileNavOpen: false }),
}));
